import { render, staticRenderFns } from "./UserActivitiesTable.vue?vue&type=template&id=042e82d7"
import script from "./UserActivitiesTable.vue?vue&type=script&lang=js"
export * from "./UserActivitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports